<template>
  <div class="table-wrapper" unselectable="on">
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img src="/imgs/logo_impay.png"></td>
        <td width="40%" align="center"></td>
        <td width="30%"></td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="input-head-text">Информация</div>
        </td>
      </tr>
      <tr>
        <td class="td-row"  colspan="3" align="left">
          <OfertText/>
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" id="btn_back" src="/imgs/back_1.png">
        </td>
        <td width="40%" align="center">
        </td>
        <td width="30%" align="right">
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import OfertText from "@/components/OfertText.vue";

export default {
  name: "OfertPage",
  components: {OfertText},
  methods: {
    backClick() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
</style>
